var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83275 1.8391e-06H1.16655C0.857161 1.8391e-06 0.560445 0.122928 0.341674 0.341738C0.122904 0.560548 0 0.857318 0 1.16676V10.5008C0 10.8103 0.122904 11.1071 0.341674 11.3259C0.560445 11.5447 0.857161 11.6676 1.16655 11.6676H8.16585C8.47524 11.6676 8.77195 11.5447 8.99072 11.3259C9.20949 11.1071 9.3324 10.8103 9.3324 10.5008V3.50028M5.83275 1.8391e-06C6.01739 -0.000297468 6.20026 0.0359394 6.37084 0.106626C6.54141 0.177312 6.69633 0.281051 6.82665 0.411868L8.91944 2.50504C9.05058 2.63542 9.1546 2.79051 9.22548 2.96133C9.29636 3.13216 9.3327 3.31533 9.3324 3.50028M5.83275 1.8391e-06V2.9169C5.83275 3.07162 5.8942 3.22001 6.00359 3.32941C6.11297 3.43882 6.26133 3.50028 6.41602 3.50028L9.3324 3.50028M3.49965 4.08366H2.3331M6.9993 6.41718H2.3331M6.9993 8.7507H2.3331",
    stroke: "#656E7B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.3324,
    height: 11.6676,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.1b3e3ef2e42b37fb57eddc3cd1dd209e.svg";
export { ForwardRef as ReactComponent };